'use client'

import { AnalyzeButton } from '@/components/ai-elements/analyze-button'
import type { LatestEarningTranscript } from '@/services/earning-transcript'
import { formatDateShort } from '@/utils/filing-utils'
import { GlobalCard, GlobalCardContent } from '../common/global-card'
import { Button } from '../ui/button'
import { TranscriptIcon } from '../icons/react'
interface EarningTranscriptCardProps {
    transcript: LatestEarningTranscript
    onChat: (
        transcript: LatestEarningTranscript,
        options?: { expandRightSidebar?: boolean }
    ) => void
    onViewTranscript: (transcript: LatestEarningTranscript) => void
    isAnalyzing?: boolean
    symbol: string
}

export function EarningTranscriptCard({
    transcript,
    onChat,
    onViewTranscript,
}: EarningTranscriptCardProps) {
    const handleChatClick = () => {
        onChat(transcript)
    }

    const handleTranscriptClick = () => {
        onViewTranscript(transcript)
    }

    return (
        <GlobalCard className="shadow-none! border border-black/3! dark:border-white/3!">
            <GlobalCardContent className="p-2.5">
                <div className="flex items-center gap-2.5">
                    <div className="h-[71px] w-[71px] rounded-[4px] bg-sidebar flex items-center justify-center">
                        <TranscriptIcon />
                    </div>
                    <div className="flex flex-col gap-2.5 flex-1">
                        <div>
                            <h3 className="text-body-semi text-black/80 dark:text-white/80">
                                {transcript.period} Transcript
                            </h3>
                            <div className="text-subheadline text-black/40 dark:text-white/40">
                                Earnings call transcript {formatDateShort(transcript.date)}
                            </div>
                        </div>
                        <div
                            onClick={(e) => e.stopPropagation()}
                            className="flex items-center gap-2.5"
                        >
                            <AnalyzeButton
                                variant="simple"
                                text={{ default: 'Chat' }}
                                textClassName="text-callout"
                                className="flex-1 h-fit min-h-fit! p-1.5!"
                                onClick={handleChatClick}
                            />
                            <Button
                                className="text-callout bg-sidebar flex-1 h-fit p-1.5!"
                                onClick={handleTranscriptClick}
                            >
                                Transcript
                            </Button>
                        </div>
                    </div>
                </div>
            </GlobalCardContent>
        </GlobalCard>
    )
}
